module.exports = __webpack_public_path__ + "static/img/2016-05-21 20.28.23.5e81e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2016-05-21 20.28.23.jpg
// module id = YfWy
// module chunks = 4